import { Spin } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

export function FillingSpinner() {
  const { t } = useTranslation();
  return (
    <div style={{
      display: 'grid',
      alignContent: 'center',
      justifyContent: 'center',
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
    }}>
      <Spin size="large" tip={t('loading') + '...'} />
    </div>
  );
}
